import { CUSTOMER_FIELD } from '../type_name'
import CustomerUtil from '@/views/components/customer/libs/util';
export const headerHandler = header => {
    const header_clone = {...header}
    header_clone.align = header_clone.align || 'end'
    return header_clone
}
export default {
    name: CUSTOMER_FIELD,
    props: {
        value: {
            type:[String, Number, Object]
        },
        header: {
            type:[String, Number, Object]
        }
    },
    data() {
        return {
            customer: {}
        }
    },
    created() {
        this.init()
    },
    methods: {
        async init() {
            this.customer = await CustomerUtil.briefInfo(this.value) || {};
        }
    },
    
    render() {
        return <span>{ this.customer.account || '-'}</span> 
    }
}